export default {
    header: {
        featureItem: {
            heading: 'Select Respondents',
            description: 'Configure who will provide an evaluation for each employee',
        },
    },
    evaluatorSelection: {
        title: '360 Feedback settings',
        description: 'Define the criteria for automatic respondent suggestions',
        question: 'For 360 feedback, how many respondents should Amélio suggest for each employee?',
        recommendation: 'Recommended: 3–7 respondents for comprehensive feedback',
        valueCorrected: 'Value has been corrected to maximum allowed ({{maxCount}})',
    },
    prioritySection: {
        title: 'Priority-Based Selection',
        descriptionLine1:
            'Drag and drop attributes to set priority levels. The system will select from',
        descriptionLine2: 'Priority 1 first, then Priority 2, and finally Priority 3 if needed.',
        priority1Label: 'Priority 1',
        priority2Label: 'Priority 2',
        priority3Label: 'Priority 3',
        priority1: 'First Choice',
        priority2: 'Second Choice',
        priority3: 'Last Resort',
        emptyState: 'No attributes added yet',
        addButton: 'Add Attribute',
        removeCriterion: 'Remove {{criterion}}',
    },
    infoCallout: {
        title: 'How Priority Selection Works',
        description:
            "The system will first try to find respondents matching the Priority 1 criteria. If there aren't enough people available, it will move to Priority 2, and then Priority 3.",
        tipLabel: 'Tip:',
        tipDescription:
            'Drag attributes between priority levels to customize the selection order for your organization.',
    },
    validation: {
        noPriority: 'At least one priority must be added',
        minReviewerCount: 'Suggested reviewer count must be at least 1',
    },
    addCriteriaModal: {
        title: 'Select a New Attribute',
    },
    criterion: {
        sameJobTitle: 'Colleagues with the same job title',
        sameDepartment: 'Colleagues in the same department',
        sameManager: 'Colleagues with the same {{managerLabel}}',
        sameOffice: 'Colleagues at the same location',
        sameEmployeeLevel: 'Colleagues at the same level',
    },
};
